import { DateTime } from "luxon";
import type { VehiclePermissionAffectedBooking } from "../../types/VehiclePermissions.types";

/** Minimal overlap row shape used by toAffectedBookings (compatible with FleetEventRow). */
export type FleetEventOverlapRow = {
  bookingId?: number;
  user?: { userId: string; firstName: string; surname: string; email: string } | null;
  start: string;
  end: string;
};

/** Returns true if [startA, endA] overlaps [startB, endB] (exclusive end not required). */
export function doTimeRangesOverlap(
  startA: string,
  endA: string,
  startB: string,
  endB: string
): boolean {
  const aStart = DateTime.fromISO(startA).toMillis();
  const aEnd = DateTime.fromISO(endA).toMillis();
  const bStart = DateTime.fromISO(startB).toMillis();
  const bEnd = DateTime.fromISO(endB).toMillis();
  return aStart < bEnd && aEnd > bStart;
}

/** Maps overlapping fleet event rows to the shape expected by the affected-bookings dialog. */
export function toAffectedBookings(
  overlaps: FleetEventOverlapRow[]
): VehiclePermissionAffectedBooking[] {
  return overlaps.map(overlap => ({
    id: overlap.bookingId,
    userBookedFor: overlap.user?.userId,
    userInfo: overlap.user
      ? {
          userId: overlap.user.userId,
          firstName: overlap.user.firstName,
          surname: overlap.user.surname,
          email: overlap.user.email
        }
      : undefined,
    start: overlap.start,
    end: overlap.end
  }));
}
